import React from "react";
import { useTimer } from "react-timer-hook";

export default function MyTimer({ expiryTimestamp, css, onExpire, showIcon = true, preselectConfirm = false , svgStyle={}}) {
	const { seconds, minutes, hours, days, isRunning, start, pause, resume, restart } = useTimer({ expiryTimestamp, onExpire: onExpire });
	return (
		<div style={{ textAlign: "center" }}>
			{/* <h1>react-timer-hook </h1>
            <p>Timer Demo</p> */}
			<div
				style={{
					fontSize: css ? css.fontSize : "1.2rem",
					color: css,
					gap: "0.5rem",
					width: "100%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				{showIcon && (
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill={css} style={svgStyle}>
						<path
							d="M4.5 1.5V0.5H7.5V1.5H4.5ZM5.5 7H6.5V4H5.5V7ZM6 11C5.38333 11 4.802 10.8812 4.256 10.6435C3.71 10.4058 3.233 10.083 2.825 9.675C2.41667 9.26667 2.09367 8.7895 1.856 8.2435C1.61833 7.6975 1.49967 7.11633 1.5 6.5C1.5 5.88333 1.61883 5.302 1.8565 4.756C2.09417 4.21 2.417 3.733 2.825 3.325C3.23333 2.91667 3.7105 2.59367 4.2565 2.356C4.8025 2.11833 5.38367 1.99967 6 2C6.51667 2 7.0125 2.08333 7.4875 2.25C7.9625 2.41667 8.40833 2.65833 8.825 2.975L9.525 2.275L10.225 2.975L9.525 3.675C9.84167 4.09167 10.0833 4.5375 10.25 5.0125C10.4167 5.4875 10.5 5.98333 10.5 6.5C10.5 7.11667 10.3812 7.698 10.1435 8.244C9.90583 8.79 9.583 9.267 9.175 9.675C8.76667 10.0833 8.2895 10.4063 7.7435 10.644C7.1975 10.8817 6.61633 11.0003 6 11ZM6 10C6.96667 10 7.79167 9.65833 8.475 8.975C9.15833 8.29167 9.5 7.46667 9.5 6.5C9.5 5.53333 9.15833 4.70833 8.475 4.025C7.79167 3.34167 6.96667 3 6 3C5.03333 3 4.20833 3.34167 3.525 4.025C2.84167 4.70833 2.5 5.53333 2.5 6.5C2.5 7.46667 2.84167 8.29167 3.525 8.975C4.20833 9.65833 5.03333 10 6 10Z"
							fill="#E17A00"
						/>
					</svg>
				)}
				{/* <span>{days}</span>:<span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span> */}
				<div>
					{preselectConfirm === true ? (
						<>
							{days.toString() > 0 ? (
								<>
									<span>{days.toString().length === 1 ? "0" + days : days}</span>:
								</>
							) : (
								""
							)}
							<span>{hours.toString().length === 1 ? "0" + hours : hours}</span>:
							<span>{minutes.toString().length === 1 ? "0" + minutes : minutes}</span>:
							<span>{seconds.toString().length === 1 ? "0" + seconds : seconds}</span>
						</>
					) : (
						<>
							<span>{hours.toString().length === 1 ? "0" + hours : hours}</span>:
							<span>{minutes.toString().length === 1 ? "0" + minutes : minutes}</span>:
							<span>{seconds.toString().length === 1 ? "0" + seconds : seconds}</span>
						</>
					)}
				</div>
			</div>
			{/* <p>{isRunning ? 'Running' : 'Not running'}</p>
            <button onClick={start}>Start</button>
            <button onClick={pause}>Pause</button>
            <button onClick={resume}>Resume</button>
            <button onClick={() => {
                // Restarts to 5 minutes timer
                const time = new Date();
                time.setSeconds(time.getSeconds() + 300);
                restart(time)
            }}>Restart</button> */}
		</div>
	);
}
